import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { FirebaseService } from './services/firebase/firebase.service';
import { HistoryRepairService } from './services/history-repair/history-repair.service';
import { NativeService } from './services/native/native.service';
import { TitleManagerService } from './shared/services/title-manager/title-manager.service';
import { NotificationService } from './shared/services/notification/notification.service';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { SettingsRepository } from './settings/state/settings.repository';
import { AppearanceService } from './shared/services/appearance/appearance.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection -- v22 migration pinned pre-existing zone-CD behavior; OnPush adoption is a separate effort
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonApp, IonRouterOutlet],
})
export class AppComponent {
  private historyRepair = inject(HistoryRepairService);
  private firebase = inject(FirebaseService);
  private native = inject(NativeService);
  private appearance = inject(AppearanceService);
  private titleManager = inject(TitleManagerService);
  private notifications = inject(NotificationService);

  constructor() {
    // Must run before firebase.init(): that call starts the sync engine, which must only ever see
    // already-repaired local state. repairOnce() (not repair()) is deliberate: it runs the repair
    // exactly once per install, gated on a version counter that a later dayStartHour change never
    // re-arms — see HistoryRepairService's doc comment for why running the repair on every launch
    // would be unsafe once dayStartHour is a live, user-editable setting.
    this.historyRepair.repairOnce();
    this.firebase.init();
    this.native.init();
    this.appearance.init();
    this.titleManager.init();
    this.notifications.init();
  }
}
